var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuccessfulPayment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 181.003,
    height: 181.003,
    viewBox: "0 0 181.003 181.003",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6408",
    "data-name": "Group 6408",
    transform: "translate(-77.805 -173.805)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6370",
    "data-name": "Group 6370",
    transform: "translate(222.681 166.212) rotate(74)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_686",
    "data-name": "Ellipse 686",
    transform: "translate(7.899 0) rotate(3)",
    fill: "none",
    stroke: "#008c77",
    strokeWidth: 5,
    strokeDasharray: "200 25"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 75.46,
    cy: 75.46,
    r: 75.46,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75.46,
    cy: 75.46,
    r: 72.96,
    fill: "none"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_687",
    "data-name": "Ellipse 687",
    cx: 66.5,
    cy: 66.5,
    r: 66.5,
    transform: "translate(13 12.745)",
    fill: "#008c74"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_38775",
    "data-name": "Path 38775",
    d: "M27.808,41.166,14.671,27.972,6.29,36.409,27.808,57.984,69.371,16.307,60.991,7.87Z",
    transform: "translate(130.415 231.774)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessfulPayment);
export default __webpack_public_path__ + "static/media/successful_payment.3ddccf61e41e1d04ab8eafa9d53511c3.svg";
export { ForwardRef as ReactComponent };